<template>
  <SuusTextField
    id="event-form__title"
    :placeholder="t$('.enter_title')"
    label="Titel"
    v-model="title"
    autofocus
    required
  ></SuusTextField>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  inject,
  PropType,
  WritableComputedRef,
} from "vue"
import SuusTextField from "app/ui-primitives/forms/SuusTextField.vue"
import useTranslate from "features/common/translate/concerns/useTranslate"
import trimIfString from "features/common/util/trimIfString"
import EventFormService from "features/events/form/event-form.service"
import { PanelIdentifier } from "features/events/form/event-form.types"
import { EventForm } from "components/EventForm/EventForm.vue"
import { Rule } from "features/common/forms/form.service"

export default defineComponent({
  name: "TitleTextField",
  components: { SuusTextField },
  props: {
    panelIdentifier: {
      type: String as PropType<PanelIdentifier>,
      required: true,
    },
  },
  setup(props) {
    const { t$ } = useTranslate("components.event_form")
    const eventFormService: EventFormService<EventForm> =
      inject("EventFormService")

    eventFormService.registerProperty({
      name: "title",
    })

    const validationRule: Rule<EventForm, "title"> = {
      field: "title",
      message: t$(".validate_title").toString(),
      selector: "event-form__title",
      panelIdentifier: props.panelIdentifier,
      action: (v) => !!v && !!v.length,
    }

    eventFormService.registerRule(validationRule as Rule<EventForm>)

    const title: WritableComputedRef<string> = computed({
      get(): string {
        return eventFormService.getFormValue("title").value || ""
      },
      set(value: string): void {
        eventFormService.setFormValue("title", trimIfString(value))
        eventFormService.validate()
      },
    })

    return {
      t$,
      title,
    }
  },
})
</script>
